import React from "react";
import { ResponsivePie } from "@nivo/pie";
import SubHeading from "../../atoms/SubHeading";
import DataTable from "react-data-table-component";
import NoData from "../../atoms/NoData";
import CardTables from "../../atoms/CardTables";
import { pollData } from "../../../data/pollData";

const EstadisticasContador = ({ data }) => {
    const colores = ["#ff0000", "#ff9500", "#ffe600", "#409fed", "#06bf1e"];
    const etiquetas = [
        "Muy insatisfecho",
        "Insatisfecho",
        "Neutral",
        "Satisfecho",
        "Muy satisfecho",
    ];

    const obtenerDistribucion = (preguntaId) => {
        const conteo = [0, 0, 0, 0, 0];
        data?.forEach((item) => {
            const valor = Number(item.answers?.[preguntaId]);
            if (valor >= 1 && valor <= 5) {
                conteo[valor - 1]++;
            }
        });
        return conteo;
    };

    const columns = [
        { name: "Respuesta", selector: row => row },
    ];

    const comentarios = data
        ?.map((item) => item?.answers?.["6"])
        ?.filter((c) => c && c?.trim() !== "");

    return (
        <div className="space-y-4 pt-10">
            <SubHeading text="Resultados de encuestas" color="blue" />
            <div className="grid md:grid-cols-2 space-y-8 md:space-y-0 md:gap-8">
                {pollData
                    .filter((p) => p.type === "radio")
                    .map((pregunta) => {
                        const distribucion = obtenerDistribucion(pregunta.name);
                        const total = distribucion?.reduce((acc, val) => acc + val, 0);

                        const chartData = distribucion?.map((value, i) => ({
                            id: etiquetas[i],
                            label: etiquetas[i],
                            value,
                            color: colores[i],
                        }));

                        return (
                            <div key={pregunta.id} className="w-auto bg-white border-2 border-slate-400 shadow-xl shadow-slate-500 rounded-lg p-4">
                                <SubHeading text={pregunta.label} color="blue" />
                                {(total === 0) ? (
                                    <p className="text-sm text-gray-500">Sin respuestas para esta pregunta.</p>
                                ) : (
                                    <div className="w-full h-64">
                                        <ResponsivePie
                                            data={chartData}
                                            margin={{ top: 10, right: 80, bottom: 80, left: 80 }}
                                            innerRadius={0.5}
                                            padAngle={1}
                                            cornerRadius={3}
                                            colors={d => d.data.color}
                                            borderWidth={1}
                                            borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                                            arcLinkLabelsSkipAngle={10}
                                            arcLinkLabelsTextColor="#333333"
                                            arcLinkLabelsThickness={2}
                                            arcLinkLabelsColor={{ from: 'color' }}
                                            arcLabelsSkipAngle={10}
                                            arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                                            legends={[
                                                {
                                                    anchor: 'left',
                                                    direction: 'column',
                                                    justify: false,
                                                    translateX: -80,
                                                    itemWidth: 100,
                                                    itemHeight: 30,
                                                    itemTextColor: '#00000040',
                                                    symbolSize: 18,
                                                    symbolShape: 'circle',
                                                }
                                            ]}
                                        />
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>

            <div className="w-full pt-8">
                <CardTables>
                    <DataTable
                        columns={columns}
                        title="Comentarios de mejora"
                        data={comentarios}
                        pagination
                        noDataComponent={<NoData />}
                    />
                </CardTables>
            </div>
        </div>
    );
};

export default EstadisticasContador;
